import React from "react";
import { GRAPH_TYPE } from "../../../constants/trendGraph/trendGraphType";
import { ElectricPanel } from "../electric";
import { DisplayCustomGraph } from "../customGraph/displayGraph";
import { Sep } from "../sep";
import { EngineTrendGraph } from "../engine";
import PropTypes from "prop-types";

export const DisplayChart = (props) => {
  const { 
    vesselId, 
    currentVessel, 
    trendCharts, 
    setGraphData, 
    setDataFetchStatus, 
    isVesselOverview, 
    setChartRef,  
    selectedGraph, 
    selectedChart, 
    graphData, 
    customCharts, 
    channels, 
    isCustomChartsCreated,
    selectedEngine,
    setSelectedEngine,
    overviewTrendIdx,
    setGraphConfig,
  } = props;
  switch (selectedGraph) {
    case GRAPH_TYPE.ELECTRIC:
      return (
        <ElectricPanel     
          vesselId={vesselId}
          currentVessel={currentVessel}
          trendCharts={trendCharts}
          setGraphData={setGraphData}
          setDataFetchStatus={setDataFetchStatus}
          isVesselOverview={isVesselOverview}
          setChartRef={setChartRef}
          selectedChart={selectedChart}
          setGraphConfig={setGraphConfig}
        />);
    case GRAPH_TYPE.CUSTOM:
      return (
        <DisplayCustomGraph  
          vesselId={vesselId}
          currentVessel={currentVessel}
          selectedChart={selectedChart}
          graphData={graphData}
          customCharts={customCharts}
          channels={channels}
          isCustomChartsCreated={isCustomChartsCreated}
          setGraphData={setGraphData}
          setDataFetchStatus={setDataFetchStatus}
        />);
    case GRAPH_TYPE.SEP:
      return (
        <Sep 
            vesselId={vesselId}
            currentVessel={currentVessel}
            selectedChart={selectedChart}
            graphData={graphData}
            setGraphData={setGraphData}
            setDataFetchStatus={setDataFetchStatus}
            trendCharts={trendCharts}
            isVesselOverview={isVesselOverview}
            setChartRef={setChartRef}
          /> )
    default: 
      return(
        <EngineTrendGraph 
          vesselId={vesselId}
          selectedChart={selectedChart}
          selectedEngine={selectedEngine}
          currentVessel={currentVessel}
          setSelectedEngine={setSelectedEngine}
          graphData={graphData}
          setGraphData={setGraphData}
          setDataFetchStatus={setDataFetchStatus}
          trendCharts={trendCharts}
          isVesselOverview={isVesselOverview}
          overviewTrendIdx={overviewTrendIdx}
          setChartRef={setChartRef}
        />);
  }
};

DisplayChart.propTypes={
  vesselId: PropTypes.string.isRequired,
  selectedChart: PropTypes.string,
  selectedEngine: PropTypes.string,
  isVesselOverview: PropTypes.bool,
  setChartRef: PropTypes.func,
  overviewTrendIdx: PropTypes.number,
  currentVessel: PropTypes.object,
  setSelectedEngine: PropTypes.func,
  graphData: PropTypes.array,
  setGraphData: PropTypes.func,
  setDataFetchStatus: PropTypes.func,
  trendCharts: PropTypes.array,
  customCharts: PropTypes.array,
  channels: PropTypes.array,
  isCustomChartsCreated: PropTypes.bool,
  selectedGraph: PropTypes.string,
  setGraphConfig: PropTypes.func,
}